// app/forgot-password/page.tsx
"use client";
import { useState } from "react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { apiRequestPasswordReset, AuthApiError } from "@/lib/auth-api";
import HexLive from "@/components/HexLive";
import Image from "next/image";

type Step = "email" | "otp" | "success" | "sent"; // Добавь "success" в список



export default function ForgotPasswordPage() {
  const [step, setStep] = useState<Step>("email");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const t = useTranslations("forgotPassword");
  const tc = useTranslations("common");
  const [phone, setPhone] = useState(""); // check bt
  const [prefics, setPrefics] = useState("");

  const validate = () => {
    const e: Record<string, string> = {};
    if (!email) e.email = t("errors.emailRequired");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = t("errors.emailInvalid");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {

    // Проверка на двойную ловушку
        if (phone || prefics) {
          console.warn("[Honeypot] Reset blocked: Bot filled hidden fields");
          
          // Имитируем успех: переключаем на шаг "Письмо отправлено"
          // Бот видит успех, а твой сервер отдыхает
          setStep("success"); 
          return;
        }
          if (!validate()) return;
          setLoading(true);
          setErrors({});
          try {
            await apiRequestPasswordReset({ email });
            setStep("sent");
          } catch (err) {
            if (err instanceof AuthApiError) {
              if (err.status === 404) setErrors({ email: t("errors.notFound") });
              else if (err.status === 429) setErrors({ general: t("errors.rateLimit") });
              else setErrors({ general: err.message });
            } else {
              setErrors({ general: t("errors.network") });
            }
          } finally {
            setLoading(false);
          }
  };

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {/* Left: Form */}
      <div className="flex-1 h-full flex flex-col px-6 py-4 lg:px-16 lg:py-8 overflow-y-auto custom-scrollbar">
        {/* Logo */}
        <div className="flex items-center justify-between mb-4 lg:mb-10">
          <Link href="/" className="text-xl font-bold tracking-widest text-zinc-900 uppercase">
            {tc("brand")}
          </Link>
          {/*<Link
            href="/signup"
            aria-label={t("backToSignin")}
            className="text-2xl font-light text-zinc-400 hover:text-zinc-900 transition-colors px-2 leading-none"
          >
            ‹
          </Link>*/}
        </div>

        <div className="flex-1 flex items-center justify-center py-2 lg:py-6">
          <div className="w-full max-w-sm my-auto space-y-1">

            {step === "email" && (
              <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <h1 className="text-xl lg:text-2xl font-semibold text-zinc-900 tracking-tight mb-1">
                  {t("title")}
                </h1>
                <p className="text-sm text-zinc-500 mb-4 lg:mb-6">
                  {t("sub")}
                </p>

                {errors.general && (
                  <div className="mb-4 p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-600 flex items-center gap-2">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/>
                    </svg>
                    {errors.general}
                  </div>
                )}

                <div className="mb-4">
                  <label className="block text-xs font-medium text-zinc-600 mb-1.5">{t("emailLabel")}</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setErrors((p) => ({ ...p, email: "" })); }}
                    placeholder="you@example.com"
                    className={`w-full px-4 py-2 rounded-xl border text-sm outline-none transition-all
                      ${errors.email ? "border-red-300 bg-red-50 focus:ring-red-200" : "border-zinc-200 focus:border-zinc-900 focus:ring-zinc-900/10"}
                      focus:ring-2`}
                  />
                  {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
                </div>
                {/* DOUBLE HONEYPOT — Двойная ловушка */}
                    <div className="absolute opacity-0 -z-10 h-0 w-0 overflow-hidden" aria-hidden="true">
                      <input
                        type="text"
                        name="user_phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        tabIndex={-1}
                        autoComplete="off"
                      />
                      <input
                        type="text"
                        name="phone_prefics"
                        value={prefics}
                        onChange={(e) => setPrefics(e.target.value)}
                        tabIndex={-1}
                        autoComplete="off"
                      />
                    </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2 bg-zinc-900 text-white text-sm font-medium rounded-xl hover:bg-zinc-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                     {t("submitting")}
                    </>
                  ) : t("submit")}
                </button>

                <p className="text-sm text-zinc-500 text-center mt-5">
                  {t("remember")}{" "}
                  <Link href="/signin" className="text-zinc-900 font-medium underline underline-offset-2 hover:no-underline">
                    {t("signin")}
                  </Link>
                </p>
              </form>
            )}

            {step === "sent" && (
              <div className="text-center">
                <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center mx-auto mb-4">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-zinc-700">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                 <h1 className="text-xl font-semibold text-zinc-900 tracking-tight mb-2">
                  {t("sentTitle")}
                </h1>
                <p className="text-sm text-zinc-500 mb-6 leading-relaxed">
                  {t("sentSub", { email })}
                </p>
                <button
                  onClick={() => setStep("email")}
                  className="text-sm text-zinc-500 underline underline-offset-2 hover:text-zinc-700 transition-colors"
                >
                  {t("resend")}
                </button>
                <div className="mt-6">
                  <Link
                    href="/signin"
                    className="text-sm text-zinc-900 font-medium underline underline-offset-2 hover:no-underline"
                  >
                    ‹ {t("backToSignin")}
                  </Link>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Right: same illustration as signin */}
      {/*
      <div className="hidden lg:flex flex-1 bg-[#0d1b35] items-center justify-center overflow-hidden h-screen sticky top-0">
        <div className="relative w-full h-full flex items-end justify-center">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0d1b35] via-[#1a4a8a] to-[#7ec8e3]" />
          <div className="absolute bottom-0 start-0 end-0 h-1/3 bg-[#4caf50] rounded-t-[60%]" />
          <div className="absolute bottom-0 start-0 end-0 h-1/4 bg-[#3d8b40]" />
          <div className="absolute bottom-12 text-center px-8">
            <p className="text-white/90 text-sm font-medium tracking-wide">
               {t("tagline")}
            </p>
          </div>
        </div>
      </div>*/}
         <div className="hidden lg:flex flex-1 bg-zinc-50 items-center justify-center relative overflow-hidden h-screen sticky top-0">
                          
                        <Image
                            src="/illustrations/subjects-network.png"
                            alt="Subjects network"
                            fill
                            className="object-contain"
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                            priority={false}
                          />
                          
                          {/* Hexagon decorations */}
                          <HexLive className="absolute right-[8%]  top-24      w-20 h-20" mode="pulse" baseOpacity={0.15} intervalSec={42} />
                          <HexLive className="absolute right-[15%] bottom-12   w-32 h-32" mode="pulse" baseOpacity={0.10} intervalSec={55} />
                          <HexLive className="absolute right-[5%]  bottom-32   w-12 h-12" mode="spark" baseOpacity={0.20} intervalSec={32} />
                          <HexLive className="absolute left-[3%]  bottom-20   w-16 h-16" mode="spark" baseOpacity={0.12} intervalSec={38} />
                          <HexLive className="absolute left-[10%] top-16       w-24 h-24" mode="pulse" baseOpacity={0.08} intervalSec={60} />
                          <HexLive className="absolute left-[20%] top-[45%]    w-10 h-10" mode="spark" baseOpacity={0.18} intervalSec={28} />
                          
                               
          </div>
      

    </div>
  );
}